import { TAGButton } from '@aspendental/shared-components-web';
import { SchemaBuilder, TextInput, TextInputSchema, useHookForm } from '@aspendental/shared-forms-web';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { FieldValues } from 'react-hook-form';
import { CustomForm, descriptionText, sendLinkButton, sendLinkButtonWrapper } from './LoginWithEmailForm.styles';
export type LoginWithEmailFormProps = {
  isPending: boolean;
  expiredPage?: boolean;
  title: string;
  description?: string;
  buttonText: string;
  handleOnSubmit: (payload: FieldValues) => void;
};
const LoginWithEmailForm: FC<LoginWithEmailFormProps> = ({
  buttonText,
  title,
  expiredPage = false,
  handleOnSubmit,
  description,
  isPending
}) => {
  const defaultValues = {
    email: ''
  };
  const schema = SchemaBuilder([{
    name: 'email',
    validation: TextInputSchema.options.email
  }]);
  const form = useHookForm({
    schema,
    defaultValues,
    mode: 'onSubmit'
  });
  return <>
			<Typography data-test-id="loginWithEmailFormTitle" textAlign="center" variant={expiredPage ? 'heroMedium' : 'header2'} data-sentry-element="Typography" data-sentry-source-file="LoginWithEmailForm.tsx">
				{title}
			</Typography>
			{expiredPage && descriptionText && <Typography sx={descriptionText} textAlign="center" variant="bodyLargeBook">
					{description}
				</Typography>}
			<CustomForm form={form as any} onSubmit={handleOnSubmit} data-sentry-element="CustomForm" data-sentry-source-file="LoginWithEmailForm.tsx">
				<TextInput name="email" required label="Email Address" enforceAlphaNumeric={false} placeholder="email@domain.com" data-private data-sentry-element="TextInput" data-sentry-source-file="LoginWithEmailForm.tsx" />
				<Box sx={sendLinkButtonWrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailForm.tsx">
					<TAGButton dataTestId="sendLinkButton" name="sendLinkButton" disabled={isPending} type="submit" sx={sendLinkButton} variant="primaryDefault" data-sentry-element="TAGButton" data-sentry-source-file="LoginWithEmailForm.tsx">
						{buttonText}
					</TAGButton>
				</Box>
			</CustomForm>
		</>;
};
export default LoginWithEmailForm;